module.exports = __webpack_public_path__ + "img/calendar.70792db6.svg";